import { getPercent } from '@recommendation/helpers'
import { PRODUCT_DEAL_TYPE, PRODUCT_PROVIDERS, PRODUCT_SOURCE } from '@tracking'

export const algoliaToProduct = (
  searchResult,
  month,
  displayAtProductModelLevel,
  position,
  sourceType,
) => {
  return {
    ...searchResult,

    grade: searchResult.backbox_grade_label,
    isRecommendation: false,
    link: searchResult.link_grade_v2,
    name: searchResult.thumbName,
    objectID: searchResult.objectID,
    price: {
      amount: searchResult.price,
      currency: searchResult.currency,
    },
    productId: searchResult.backmarketID,
    reviewRating: searchResult.reviewRating,
    sourceType,
    thumbnail: searchResult.image1,
    titleModel: searchResult.title_model,
    warranty: `${searchResult.warranty} ${month}`,
    position,
    sellerId: searchResult?.merchant_link_grade_v2?.params?.merchantId,
    listingId: searchResult.listingID,
    productAlgoliaReranked:
      // eslint-disable-next-line no-underscore-dangle
      searchResult?._rankingInfo?.promotedByReRanking ?? false,
    variant_fields: displayAtProductModelLevel
      ? searchResult.variant_fields
      : {},
    description: displayAtProductModelLevel
      ? searchResult?.sim_lock?.split(' ').slice(-1).join()
      : searchResult?.sub_title_elements.join(' - '),
    percentageDifference: getPercent(
      searchResult.price,
      searchResult?.referencePrice?.amount,
    ),
  }
}
export const toTrackingData = ({
  position,
  reviewRating,
  name,
  title,
  backmarketID,
  link,
  price,
  currency,
  sourceType,
  backbox_grade_value,
  merchant_link_grade_v2,
  listingID,
  productAlgoliaReranked,
} = {}) => {
  return {
    list: sourceType,
    product: {
      averageRate: reviewRating?.average,
      name: name || title,
      id: backmarketID,
      // TODO: URL-352 Use id when available in Algolia to get the UUID
      uuid: link?.params?.uuid,
      price: price?.amount,
      currency,
      list: sourceType,
      position,
      variant: backbox_grade_value,
      merchantId: merchant_link_grade_v2?.params?.merchantId,
      listingId: listingID,
      dealType: PRODUCT_DEAL_TYPE.NORMAL,
      numberTotalReviews: reviewRating?.count,
      source: PRODUCT_SOURCE.SEARCH,
      provider: PRODUCT_PROVIDERS.ALGOLIA,
      productAlgoliaReranked,
    },
  }
}
